import { connect } from 'react-redux'
import { checkQingJiaDel } from './actions'
import Setting from './main'


const mapDispatchToProps = {
    checkQingJiaDel
}
const mapStateToProps = (state) => {
  return {
    ...state.QingJiaDelCheck
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
